export type Locale = 'fr' | 'en';

const dateLocales: Record<Locale, string> = {
  fr: 'fr-ML',
  en: 'en-GB',
};

export function formatDate(iso: string, locale: Locale = 'fr'): string {
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(dateLocales[locale], {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function formatDateRange(start: string, end: string, locale: Locale = 'fr'): string {
  return `${formatDate(start, locale)} – ${formatDate(end, locale)}`;
}

export function formatXof(amount: number, locale: Locale = 'fr'): string {
  return new Intl.NumberFormat(locale === 'fr' ? 'fr-ML' : 'en-US', {
    style: 'currency',
    currency: 'XOF',
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatUsd(amount: number, fractionDigits = 2): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

export function formatJvc(amount: number): string {
  return `${new Intl.NumberFormat('fr-ML').format(amount)} JVC`;
}

export function pickLocale<T extends { fr: string; en: string }>(value: T, locale: Locale): string {
  return value[locale] || value.fr;
}
